import Pressable from './ComponentChipPressable/Index'
import Label from './ComponentChipLabel/Index'

export const Chips = {
    Pressable,
    Label
}